/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loading[_ngcontent-%COMP%]{background-image:url(/assets/images/loading-spinner.svg);background-size:120px;background-position:center center;background-repeat:no-repeat;height:350px;display:flex;flex-direction:column;justify-content:center;align-items:center}.loading[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
